export class ButtonLoader {
    private btn: any;
    private text: string;

    constructor(selector: string) {
        this.btn = jQuery(selector) as any;
    }

    /** Inicializa o loader no botão */
    loading(loadingMsg: string, loadingIcon = 'fas fa-spinner fa-pulse') {
        const loadingText = `<i class="${loadingIcon}"></i> ${loadingMsg}`;

        if (this.btn.html() !== loadingText) {
            this.text = this.btn.html();
            this.btn.html(loadingText);
            this.btn.prop('disabled', true);
        }
    }

    /** Finaliza o loader no botão */
    reset() {
        this.btn.html(this.text);
        this.btn.prop('disabled', false);
    }

    /** Finaliza o loader no botão e já inicia um novo loader */
    resetAndLoading(loadingMsg: string, loadingIcon = 'fas fa-spinner fa-pulse') {
        this.reset();
        this.loading(loadingMsg, loadingIcon);
    }
}
